import React from "react";
import Cart from "../components/Cart/Cart";
import Navbar from "../components/Home/Navbar";

export default function CartPage() {
  return (
    <div>
      <Navbar />
      <Cart />
    </div>
  );
}
